/**
 * SPA-routed link to another Beacon page, for id columns and cross-references.
 * Appends the region here so no caller can drop it.
 *
 * Pass `newTab` to open the target in a new browser tab (native anchor, no SPA
 * navigation) — used by the bulk search tables so a row's detail opens beside
 * the result list instead of replacing it.
 *
 *   <DetailLink to={`/artifact?id=${encodeURIComponent(id)}`}>{id}</DetailLink>
 */
import { ReactNode } from 'react';
import Link from '@cloudscape-design/components/link';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'src/store/hooks';
import { withRegion } from 'src/constants';

export const DetailLink = (
  { to, children, newTab = false }: { to: string; children: ReactNode; newTab?: boolean },
) => {
  const navigate = useNavigate();
  const region = useAppSelector((state) => state.env.region);
  const target = withRegion(to, region);
  // New tab: external renders the new-tab icon; Cloudscape adds rel="noopener noreferrer".
  if (newTab) {
    return (
      <Link href={target} target="_blank" external externalIconAriaLabel="Opens in a new tab">
        {children}
      </Link>
    );
  }
  return (
    <Link href={target} onFollow={(e) => { e.preventDefault(); navigate(target); }}>
      {children}
    </Link>
  );
};
